import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../../services/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-force-password-reset',
  imports: [CommonModule, FormsModule],
  templateUrl: './force-password-reset.component.html',
  styleUrl: './force-password-reset.component.css'
})
export class ForcePasswordResetComponent {

  router = inject(Router);

  @Input() session: string = '';
  @Input() username: string = '';
  @Output() emitterOpenTerms = new EventEmitter<boolean>();
  @Output() emitterPendingLoginData = new EventEmitter<any>();

  @Output() token = new EventEmitter<string>();

  passwordFieldType: string = 'password';
  newPassword: string = '';
  showTooltip: boolean = false;
  errorMessage: string = '';

  passwordValidations = {
    minLength: false,
    number: false,
    lowercase: false,
    uppercase: false,
    specialChar: false,
  };

  constructor (private authService: AuthService) { }

  togglePasswordVisibility (): void {
    this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
  }


  validatePassword (): void {
    const pw = this.newPassword || '';
    this.passwordValidations = {
      minLength: pw.length >= 8,
      number: /\d/.test(pw),
      lowercase: /[a-z]/.test(pw),
      uppercase: /[A-Z]/.test(pw),
      specialChar: /[!@#$%^&*()\[\]{}\-_+=~`'"“”‘’.,:;?<>\\|]/.test(pw) || /\s/.test(pw),
    };
  }

  onResetPassword () {
    this.errorMessage = '';
    if (!this.newPassword) {
      this.errorMessage = 'Devi creare una nuova password';
      return;
    }

    this.validatePassword();

    const validations = Object.values(this.passwordValidations);
    const isPasswordValid = validations.every(v => v);

    if (!isPasswordValid) {
      // Optional: show feedback to user
      this.errorMessage = "La password non soddisfa tutti i requisiti.";
      return;
    }

    this.authService.forceChangePwd(this.username, this.newPassword, this.session).subscribe(async (data) => {
      if (data.accessToken) {
        sessionStorage.setItem('access_token', data.accessToken);
        sessionStorage.setItem('username', data.username);
        const companyId = data.companyId.toString();
        sessionStorage.setItem('companyId', companyId);
        sessionStorage.setItem('setup', JSON.stringify({
          companyName: data.companyName || '',
          companyRole: data.companyRole || '',
          role: data.role || '',
          regionsIds: data.regionsIds || []
        }));

        if (!data.hasAcceptedTerms) {
          // open terms and conditions if the user hasn't accepted yet
          //this.openTerms = true;
          this.emitterPendingLoginData.emit(data);
          //this.isTermsOpen = true;
          this.emitterOpenTerms.emit(true);
          return;
        }

        this.token.emit(data.accessToken);
        this.router.navigate(['/dashboard']);

      }
    })

  }

}
